import { Box, Tabs } from '@zillow/constellation-10';

import PropertiesConstants from '../../../constants/PropertiesConstants';

import { flexContainerStyles, rightSubFlexContainerStyles } from '../styles';

import SearchBox from '../../SearchBox';

import type { FilterOptions } from '../hooks';

type Props = {
  isLoading: boolean;
  isLoadingForSearchbox: boolean;
  currentSearchText?: string;
  filterOptions: FilterOptions;
  currentFilterOptionId?: string;
  handleFilterTabClick: (
    selectedFilterOption?: (typeof PropertiesConstants.PROPERTIES_SUBNAV_FILTER_OPTIONS)[number],
  ) => void;
  handleSearch: (newSearchText?: string) => void;
};

const SubHeadingSection = ({
  isLoading,
  isLoadingForSearchbox,
  currentSearchText,
  filterOptions,
  currentFilterOptionId,
  handleFilterTabClick,
  handleSearch,
}: Props) => {
  const renderFlexibleSearchbox = () => {
    return (
      <Box css={rightSubFlexContainerStyles}>
        <Box css={{ width: '100%', maxWidth: '370px' }}>
          <SearchBox
            aria-label="Search by city, address and ZIP code"
            placeholder="Search by city, address and ZIP code"
            onSearch={handleSearch}
            initialText={currentSearchText}
            isSearching={isLoadingForSearchbox}
          />
        </Box>
      </Box>
    );
  };

  const renderFilterTab = (filterOption: (typeof PropertiesConstants.PROPERTIES_SUBNAV_FILTER_OPTIONS)[number]) => {
    /**
     * @param {boolean} [id] - ID of the tab
     * @param {String} [label] - Label of the button
     * @param {Number} [count] - Number display after the label
     * */
    const { id, label, count } = filterOption;

    const SUBNAV_FILTER_TYPES = PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE;

    // Only need to show all, for rent, and off-market.
    if (
      !(id === SUBNAV_FILTER_TYPES.ALL || id === SUBNAV_FILTER_TYPES.ON_MARKET || id === SUBNAV_FILTER_TYPES.OFF_MARKET)
    ) {
      return null;
    }

    return (
      <Tabs.Tab
        key={id}
        value={id}
        disabled={isLoading}
        data-test={`SubHeadingSection-Tab-${id}`}
        css={{
          color: id === currentFilterOptionId ? 'text.accent.brand.hero' : 'text.neutral',
          xl: {
            // eslint-disable-next-line curly-quotes/no-straight-quotes
            '&[aria-selected="true"]:before': {
              backgroundColor: 'transparent',
            },
          },
        }}
      >
        {`${label} (${count || 0})`}
      </Tabs.Tab>
    );
  };

  const renderFlexibleFilterTabs = () => {
    return (
      <Box css={{ maxWidth: { base: '100%', lg: '50%' } }}>
        <Tabs.Root
          selected={currentFilterOptionId}
          onSelectedChange={(id: string) => handleFilterTabClick(filterOptions.options[id])}
        >
          <Tabs.List
            aria-label="SubNav Filter Tabs"
            css={{
              borderBottomStyle: 'none',
            }}
          >
            {Object.keys(filterOptions.options).map((id) => renderFilterTab(filterOptions.options[id]))}
          </Tabs.List>
        </Tabs.Root>
      </Box>
    );
  };

  const renderSubHeadingSection = () => {
    return (
      <Box css={flexContainerStyles} className="SubHeadingSection-Row">
        {renderFlexibleSearchbox()}
        {renderFlexibleFilterTabs()}
      </Box>
    );
  };

  return renderSubHeadingSection();
};

export default SubHeadingSection;
